import { io } from "socket.io-client";
import { config } from "../Config/config";

const socket = io(config.base.socket);
export default socket;
